import { useLocation, useParams, useSearchParams, useNavigate } from "react-router-dom";
import RSSB_LOGO from "../assets/RSSB_LOGO.jpeg";
import React, { useEffect, useState } from "react";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import Swal from "sweetalert2";
import { useTable } from 'react-table';
import '../styles/noPrint.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import ApproverModal from './ApproverModal';
const IssueRequestPreview = () => {
const location = useLocation();
const [searchParams] = useSearchParams();
const type = searchParams.get('type');
const personId=searchParams.get('personId')
const navigate = useNavigate()

let id = searchParams.get('draftId')? searchParams.get('draftId') : location.state?.id
const [data,setData] = useState([])
const [rowData,setRowData] = useState([])
const token = localStorage.getItem('token')
const [profileDetails, setProfileDetails] = useState(null);
const centerCode = localStorage.getItem('code')
const email = localStorage.getItem('email')
const name = localStorage.getItem('name');
const badgeId = localStorage.getItem('badgeId');
const pin = localStorage.getItem('pin');
const [personOptions, setPersonOptions] = useState([]);
const [modalShow, setModalShow] = useState(false);
const [draftId, setDraftID] = useState(null);
const [departmentForModal, setDepartmentForModal] = useState(null);
    useEffect(() => {
      if (!token) {
        // Redirect to login page with additional data
        navigate(
          `/?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}&type=issueRequest`
        );
        return;
      }
        const fetchCenterInfo = async () => {
          try {
           
            const response = await apiClient.get(`${SERVER_BASE}/centerInfoForDC`, {
                params: { code:centerCode },
              headers: {
                'Authorization': `Bearer ${token}`, // Add the JWT token in the header
              },
            });
            setData(response.data[0]);
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        };
    
        fetchCenterInfo();
      }, []);


      
    const fetchProfileDetails = async () => {
        try {
          const response = await apiClient.get(`${SERVER_BASE}/getProfile`, { params: { email } });
          
          setProfileDetails(response.data?.[0] || null); // Assume the first row contains the profile data
        } catch (err) {
          console.error('Error fetching profile details:', err);
          setProfileDetails(null);

        }
      };


      const handleApprove = () => {
        // SweetAlert2 for PIN input
        Swal.fire({
          title: 'Enter your PIN',
          input: 'password',
          inputPlaceholder: 'Enter your PIN',
          showCancelButton: true,
          cancelButtonText: 'Cancel',
          confirmButtonText: 'Submit',
          inputValidator: (value) => {
            if (!value) {
              return 'Please enter your PIN.';
            }
            if (value !== pin) {
              return 'Invalid PIN. Please try again.';
            }
          },
        }).then((result) => {
          if (result.isConfirmed) {
            // Proceed with the approval if PIN matches
            const approvedBy = name;
            const approvedByBadge = badgeId;
    
            // Send the approval request to the backend
            apiClient.post(`${SERVER_BASE}/approveIssueRequest/${id}`, {
              approvedBy,
              approvedByBadge
            })
              .then(response => {
                Swal.fire({
                    icon: 'success',
                    title: 'Issue Request Approved!',
                    text: 'The issue request has been approved successfully.',
                    confirmButtonText: 'OK',
                }).then(() => {
                    window.location.reload();
                });
              })
              .catch(err => {
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: `Failed to approve the issue request: ${err.response?.data?.message || err.message}`,
                  confirmButtonText: 'OK',
                });
              });
            }
            // fetchDraftData();
        });
      };
      const handleSendForApproval = () => {
        if (!token) {
          window.location.href = "/";
          return;
        }
    
        setDraftID(id);
        setDepartmentForModal(rowData.receivingDepartment);
        setModalShow(true);
      };
    
      const getFilteredOptions = () => {
        return personOptions.filter(
          person =>
            person.position === "Authorized Person" ||
            person.sewadarOf === departmentForModal
        );
      };
    
      // Handle Modal Submit (send for approval)
      const handleModalSubmit = async (personId) => {

        const selectedPerson = personOptions.find(
          (person) => String(person.value) === String(personId)
        );
        const mobileNo = selectedPerson?.mobileNo;
        try {
          // API call to send for approval
          await apiClient.post(
            `${SERVER_BASE}/sendForApproval/${draftId}`,
            { personId, type: 'issueRequest' },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
    
          const baseLink = `https://rs.iosystem.in/IssueRequestPreview?id=${draftId}`;
          const fullLink = `${baseLink}&draftId=${draftId}&personId=${personId}&type=issueRequest`;
          const whatsappLink = `https://wa.me/${mobileNo}?text=${encodeURIComponent(
            `Please Approve this Issue Request: ${fullLink}`
          )}`;
          window.open(whatsappLink, "_blank");
    
          setModalShow(false); // Close modal after successful submission
        } catch (error) {
          console.error("Error sending for approval:", error);
          setModalShow(false); // Close modal on error
        }
      };
      const closeModal = () => {
        setModalShow(false); // Close the modal
      };
      useEffect(() => {
        const fetchRowData = async () => {
          try {
           
           const response = await apiClient.get(`${SERVER_BASE}/viewIssueRequest/${id}`, {
            headers: {
              Authorization: `Bearer ${token}`, // Ensure token is valid
            },
          });
          
            setRowData(response.data);
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        };
        const fetchPersons = async () => {
          try {
            const response = await apiClient.get(`${SERVER_BASE}/getApprovers`, { // Assuming there's an endpoint to fetch persons
              headers: {
                Authorization: `Bearer ${token}`, // Add the JWT token in the header
              }
            });
            setPersonOptions(
              response.data.map((person) => ({
                value: person.id,
                label: `${person.firstName} ${person.lastName} - ${person.contactNo}`,
                 // Assuming 'firstName' and 'lastName' are available
                mobileNo: person.contactNo,
                badgeId: person.badgeId,
                position: person.position,
                sewadarOf: person.sewadarOf
              }))
            );
    
          } catch (error) {
            console.error('Error fetching persons for approval:', error);
          }
        };
        fetchPersons();
        fetchRowData();
        fetchProfileDetails();
      }, []);

      const columns = React.useMemo(
        () => [
          { Header: "S.No", Cell: ({ row }) => row.index + 1 },
          {
            Header: 'Item Name',
            accessor: 'item',
          },
          {
            Header: ' Requested',
            accessor: 'quantity',
          },
          {
            Header: ' Approved',
            accessor: 'approvedQuantity',
          },
          {
            Header: 'UOM',
            accessor: 'uom',
          },
          {
            Header: 'Returnable',
            accessor: 'returnable',
          },
          {
            Header: 'Remarks',
            accessor: 'itemRemarks',
          },
        ],
        []
      );
    
      const tableInstance = useTable({
        columns,
        data: rowData?.inventory || [],
      });
    
      const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
      } = tableInstance;

    const organization = {
        name: data?.centerName,
        addressLine1: data?.addressLine1,
        addressLine2: data?.addressLine2,
        addressLine3: data?.addressLine3,
        mobile1: data?.mobile1,
        mobile2: data?.mobile2,
        gstin:data?.gstin,
        contactPerson1:data?.contactPerson1,
        contactPerson2:data?.contactPerson2,
        position1:data?.position1,
        position2:data?.position2
    };

    const itemDetails = rowData?.itemDetails || [];
    const remarks = rowData?.remarks || '';
    const footer = 'H.O. Dera Baba Jaimal Singh, Beas, Distt. Amritsar, Punjab 143 204, India';

    return (
        <div style={{ margin: 'auto', padding: '20px', fontFamily: 'Arial, sans-serif', maxWidth: '650px' ,fontSize:'14px'}}>
            {/* Header Section */}
            
                {/* Back Button - Always visible */}
                <div className="d-flex justify-content-between no-print mb-3">
              {/* Left side - Back button */}
              <button className="btn btn-secondary" onClick={() => navigate(-1)}>
                Back
              </button>

              {/* Right side - Approval buttons */}
              <div>
                {profileDetails &&
                  String(profileDetails.id) !== String(personId) &&
                  String(profileDetails.id) !== String(rowData?.authorizedPersonId) &&
                  rowData.status !== 'Approved' && (
                    <button className="btn btn-secondary me-2" onClick={handleSendForApproval}>
                      <FontAwesomeIcon icon={faPaperPlane} /> Send for Approval
                    </button>
                  )}

                {profileDetails &&
                  (String(profileDetails.id) === String(personId) ||
                    String(profileDetails.id) === String(rowData?.authorizedPersonId)) &&
                  rowData.status !== 'Approved' && (
                    <button className="btn btn-success" onClick={handleApprove}>
                      Approve
                    </button>
                  )}
              </div>
            </div>
              <div className="d-flex justify-content-between align-items-start border-bottom pb-2">
                {/* Left side: Logo and organization details */}
                <div className="d-flex align-items-start">
                  <img src={RSSB_LOGO} alt="Logo" className="me-3" style={{ height: '65px' }} />
                  <div className="text-start">
                    <h6 className="mb-0">{organization?.name}</h6>
                    <p className="mb-0">{organization?.addressLine1}</p>
                    <p className="mb-0">{organization?.addressLine2}</p>
                    <p className="mb-0">{organization?.addressLine3}</p>
                  </div>
                </div>

                {/* Right side: Receiving department, request number, and date */}
                <div className="text-end mt-2" style={{ fontSize: '14px' }}>
                  <h6 className="mb-0 fw-bold">{rowData?.receivingDepartment}</h6>
                  <p className="mb-0">{rowData?.requestNumber}</p>
                  <p className="mb-0">
                    {" "}
                    {rowData?.requestDate
                      ? new Intl.DateTimeFormat("en-US", {
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                        }).format(new Date(rowData.requestDate))
                      : ""}
                  </p>
                </div>
              </div>
        <div className="text-center border-bottom mt-2" style={{ fontSize: '14px', lineHeight: '1.6' }}>
            <h3 className="fw-bold mb-1" style={{ fontSize: '15px' }}>
                ISSUE REQUEST
            </h3>
        </div>

            
            <div className="mt-3" style={{ fontSize: '16px' }}>
                <div className="d-flex justify-content-between">
                    <p className="mb-0">
                    To : <span className="fw-bold">
                        {rowData?.issuerDepartment}</span> 
                    </p>
                </div>
            </div>

            <table {...getTableProps()} className="table table-bordered table-striped mt-2">
              <thead className="thead-light">
                {headerGroups.map(headerGroup => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map(column => (
                      <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map(row => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map(cell => (
                        <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>

            <div className='mt-2 d-flex justify-content-between' style={{fontSize: '14px'}}>
                <p className="mb-0">
                    <span className="fw-bold">Remarks: </span> 
                    <span className="">{rowData?.remarks}</span>
                </p>
            </div>

            <div className="mt-2" style={{ fontSize: '14px' }}>
            <div className="d-flex justify-content-between align-items-center">
                <div>
                    <p className="mb-1">
                        <span className="fw-bold">Prepared By:</span> {rowData?.createdBy} ({rowData?.createdByBadge})
                    </p>
                    {rowData?.approvedBy && <>
                    <p className="mb-1">
                        <span className="fw-bold">Approved By:</span> {rowData?.approvedBy} ({rowData?.approvedByBadge})
                    </p>
                    </>}
                </div>
            </div>
                <p className="text-end fw-bold">Signatory</p>
            </div>
            <div
            className="footer"
            style={{
              textAlign: "center",
              marginTop: "20px",
              fontSize: "12px",
              borderTop: "1px solid black",
              paddingTop: "10px",
              fontWeight: "bolder",
              width: "100%", // Ensure the footer width is constrained
              boxSizing: "border-box", // Include padding and borders in width
            }}
          >
            H.O. Dera Baba Jaimal Singh, Beas, Distt. Amritsar, Punjab 143 204, India
          </div>

          {/* CSS for print media */}
          <style>
            {`
              @media print {
                .footer {
                  position: absolute;
                  bottom: 0;
                  width: 100%;
                  page-break-before: always;
                  box-sizing: border-box; /* Include padding and border in width */
                }
              }
            `}
          </style>
          <ApproverModal
        show={modalShow}
        title="Send for Approval"
        options={getFilteredOptions()}
        close={closeModal} // Pass close function
        onSubmit={handleModalSubmit}
      />
        </div>
    );
};

export default IssueRequestPreview;
